module.exports = {
          srcSet: __webpack_public_path__ + "529bbe659f0925c32a0cf56f22ba3a51-320.png"+" 320w",
          images:[ {path: __webpack_public_path__ + "529bbe659f0925c32a0cf56f22ba3a51-320.png",width: 320,height: 200}],
          src: __webpack_public_path__ + "529bbe659f0925c32a0cf56f22ba3a51-320.png",
          toString:function(){return __webpack_public_path__ + "529bbe659f0925c32a0cf56f22ba3a51-320.png"},
          placeholder: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAGCAYAAAD68A/GAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAcUlEQVR4nH3OsQ4BQRRG4TsO526zz4NGYpEsCvEGCk/h6Zk1Cs0WfyaZ+xUn0Jhd5vTOIdGOzB7t68eI3tABfZK5QR/oHX2hB/Rc4a7hCi/oCT2iV3SPrtHtf0tmLFvTr43MsmqNZdoXlQYXDdZbxGdvnboJkdJNXbwAAAAASUVORK5CYII=",
          width: 320,
          height: 200
        }